// extracted by mini-css-extract-plugin
module.exports = {"lightInput":"SearchBar_lightInput__pQDDp","close":"SearchBar_close__l0uXF"};